import React from 'react';
import MaskedInput from 'react-text-mask';
import PropTypes from 'prop-types';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

const numberMask = createNumberMask({
  prefix: '',
  allowDecimal: false,
  includeThousandsSeparator: false,
  allowLeadingZeroes: true,
});

const TextMask = props => {
  const { inputRef, ...other } = props;
  return <MaskedInput {...other} ref={ref => inputRef && inputRef(ref ? ref.inputElement : null)} mask={numberMask} guide={false} showMask />;
};

TextMask.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

export default TextMask;
